import { useImperativeHandle, useRef, type Ref } from 'react';
import type { PaymentFormRef, Transaction } from '../../types';
import { useAuth } from '@auth';
import { StripePaymentForm } from './Stripe';
import { MercadoPagoPaymentForm } from './MercadoPago';
import PaymentLoadingState from './PaymentLoadingState';

interface PaymentGatewayFormProps {
  amountCents: number;
  scheduleId?: string;
  onPaymentConfirmed: (transaction: Transaction) => void;
  onReady?: () => void;
  onError?: () => void;
  ref?: Ref<PaymentGatewayFormRef>;
}

export interface PaymentGatewayFormRef {
  submit(): Promise<void>;
}

export default function PaymentGatewayForm({ ref, amountCents, scheduleId, onPaymentConfirmed, onReady, onError }: PaymentGatewayFormProps) {
  const { gateway } = useAuth();
  const formRef = useRef<PaymentFormRef>(null);

  useImperativeHandle(ref, () => ({
    async submit() {
      if (formRef.current) {
        await formRef.current.submit();
      }
    },
  }), []);

  if (gateway === 'stripe') {
    return (
      <StripePaymentForm
        ref={formRef}
        amountCents={amountCents}
        scheduleId={scheduleId}
        onPaymentConfirmed={onPaymentConfirmed}
        onReady={onReady}
        onError={onError}
      />
    );
  }

  if (gateway === 'mercadopago') {
    return (
      <MercadoPagoPaymentForm
        ref={formRef}
        amountCents={amountCents}
        scheduleId={scheduleId}
        onPaymentConfirmed={onPaymentConfirmed}
        onReady={onReady}
        onError={onError}
      />
    );
  }

  return <PaymentLoadingState />;
}
